import { useContext } from "react";
import Map from "./Map";
import DevTools from "./DevTools";
import StatusBar from "./StatusBar";
import { GameState } from "./GameState";
import MainMenu from "./MainMenu/MainMenu";
import Instructions from "./MainMenu/Instructions";
import GameOver from "./MainMenu/GameOver";
import { isDev } from "../helper/DevHelper";
import Messages from "./Messages";
import { useWindowDimensions } from "../hooks";

const devTools = () => {
  if (isDev()) {
    return <DevTools />;
  } else {
    return null;
  }
};

const AudioControl = () => {
  // TODO lol
  return null;
};

const Game = () => {
  const state = useContext(GameState);
  const { height, width } = useWindowDimensions();

  if (width < 1366 || height < 768) {
    return (
      <div className="maintitle-sub">
        "Screen below minimum required size, sorry for the inconvenience"
      </div>
    );
  }

  if (state.gameMode === 0) {
    // main menu
    return (
      <div>
        <MainMenu />
        <AudioControl />
      </div>
    );
  } else if (state.gameMode === 1) {
    // instructions
    return (
      <div>
        <Instructions />
        <AudioControl />
      </div>
    );
  } else if (state.gameMode === 2) {
    // game
    if (state.music["hitkit"].paused) {
      state.playSong("hitkit");
    }
    return (
      <div className="game">
        <StatusBar />
        <Messages />
        <Map />
        <AudioControl />
        {devTools()}
      </div>
    );
  } else if (state.gameMode === 3) {
    // loss screen
    return (
      <div>
        <GameOver />
        <AudioControl />
      </div>
    );
  } else {
    // invalid game mode
    return "invalid game mode " + state.gameMode + " :(";
  }
};

export default Game;
